<template>
  <div
    v-show="products.length && items.length"
    class="minicart--cart-upsell-wrapper"
  >
    <div class="minicart minicart--cart-upsell">
      <h6
        class="h6 upsell-minicart__title"
        v-html="strings.general.title"
      />

      <vue-flickity
        ref="upsells"
        :key="products"
        :options="{
          'prevNextButtons': true,
          'pageDots': false,
          'cellAlign': 'left',
        }"
      >
        <div
          v-for="item in products"
          :key="item.id"
          class="upsell-minicart__item flex"
        >
          <a
            class="upsell-minicart-item__image cart-item__image"
            :class="{ 'cart-item__image--png': item.images[0].includes('.png') }"
            :href="item.url"
          >
            <img
              :src="item.images[0]"
              alt="free-gift-image"
              width="92"
              height="92"
            >
          </a>
          <div class="upsell-minicart-item__text">
            <h6 class="upsell-minicart-item__title">
              <a :href="item.url">{{ item.title }}</a>
            </h6>
            <p class="upsell-minicart-item__price font-semibold">
              {{ price(item) }}
            </p>
            <button
              class="upsell-minicart__add-cta btn btn--white btn--border-black w-full"
              @click="addItemToCart(item)"
            >
              Add
            </button>
          </div>
        </div>
      </vue-flickity>
    </div>
  </div>
</template>

<script>
import {productPrice} from '../helpers/product'
import {useCartStore} from '../pinia/CartStore'
import {mapState, mapActions} from 'pinia'
import vueFlickity from 'vue-flickity'

export default {
  components: {
    vueFlickity
  },
  props: {},
  data() {
    return {
      strings: {...window.theme.cart.strings, ...window.theme.upsellPopups.strings},
      products: []
    }
  },
  computed: {
    ...mapState(useCartStore, [
      'items'
    ])
  },
  watch: {
    items: function () {
      this.fetchProducts()
    }
  },
  mounted() {
    this.fetchProducts()
  },
  updated() {
    this.$nextTick(() => this.$refs.upsells.rerender())
  },
  methods: {
    ...mapActions(useCartStore, [
      'addItems'
    ]),
    payload(item) {
      return {
        items: [
          {
            id: item.id,
            quantity: 1
          }
        ]
      }
    },
    limit() {
      return window.theme?.upsellMinicart?.limit ?? 2
    },
    async fetchProducts() {
      this.products = []

      if (this.limit() === 0) {
        return
      }

      await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${this.items[0].product_id}&limit=${this.limit()}&intent=complementary`)
        .then(response => response.json())
        .then(({products}) => {
          if (products && products?.length > 0) {
            products.forEach(product => {
              if (!this.products.find(item => item.id === product.id)) {
                this.products.push(product)
              }
            })
          }
        })

      if (this.products?.length === this.limit()) {
        return
      }

      const fallbackLimit = this.limit() - this.products?.length ?? 0
      await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${this.items[0].product_id}&limit=${fallbackLimit}&intent=related`)
        .then(response => response.json())
        .then(({products}) => {
          if (products && products?.length) {
            products.forEach(product => {
              if (!this.products.find(item => item.id === product.id)) {
                this.products.push(product)
              }
            })
          }
        })
    },
    defaultVariant(item) {
      return item.variants[0] || item
    },
    async addItemToCart(item) {
      await this.addItems(this.payload(this.defaultVariant(item)))
    },
    price(item) {
      return productPrice(item.price)
    },
  }
}
</script>
